import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as ReactBootstrap from 'react-bootstrap';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import FiltersBar from '../../components/FiltersBar.js';
import PagingBar from '../../components/PagingBar.js';
import Title from '../../components/Title.js';
import Button from '../../components/Button.js';
import IconDownload from '../../components/icons/IconDownload.js';
import IconStatus from '../../components/icons/IconStatus.js';
import HomeBodyPart2ContextualAction1 from './HomeBodyPart2ContextualAction1.js';
import HomeBodyPart2ContextualAction2 from './HomeBodyPart2ContextualAction2.js';
import HomeBodyPart2ContextualAction3 from './HomeBodyPart2ContextualAction3.js';
import ApiService from '../../services/ApiService.js';
import SecurityService from '../../services/SecurityService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';
import { download } from '../../utils/download.js';
import { isValid } from '../../utils/is-valid.js';

const HomeBodyPart2 = ReactRouterDOM.withRouter(function () {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const history = ReactRouterDOM.useHistory();
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [filtersValues, setFiltersValues] = React.useState(() => {
    const savedFiltersValues = sessionStorage.getItem('filtersOperations');
    console.log(savedFiltersValues);
    return savedFiltersValues ? JSON.parse(savedFiltersValues) : [null, null, null, null, null, null];
  });
  const [items, setItems] = React.useState([]);
  const [dataSourceOperationTypeId, setDataSourceOperationTypeId] = React.useState([]);
  const [dataSourceBusinessUnitId, setDataSourceBusinessUnitId] = React.useState([]);
  const [dataSourceSegmentId, setDataSourceSegmentId] = React.useState([]);
  const [dataSourceBranchId, setDataSourceBranchId] = React.useState([]);
  const [dataSourceUserId, setDataSourceUserId] = React.useState([]);
  const [contextualAction, setContextualAction] = React.useState(null);
  const [contextualActionData, setContextualActionData] = React.useState(null);
  const [contextualActionPath, setContextualActionPath] = React.useState(null);
  const [contextualActionBody, setContextualActionBody] = React.useState(null);
  const [contextualActionValidated, setContextualActionValidated] = React.useState(null);
  const bodyRefContextualAction0 = React.useRef(null);
  const bodyRefContextualAction1 = React.useRef(null);
  const bodyRefContextualAction2 = React.useRef(null);

  React.useEffect(() => {
    fetchDataSourceOperationTypeId();
    fetchDataSourceBusinessUnitId();
    fetchDataSourceSegmentId();
    fetchDataSourceBranchId();
    fetchDataSourceUserId();
  }, []);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [filtersValues]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, filtersValues]);

  const fetchDataSourceOperationTypeId = async function () {
    let records = null;
    try {
      records = await ApiService.getOperationTypes(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceOperationTypeId(
      records.map((record) => [record.operationTypeId, record.name])
    );
  }
  
  const fetchDataSourceBusinessUnitId = async function () {
    let records = null;
    try {
      records = await ApiService.getBusinessUnits(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceBusinessUnitId(
      records.map((record) => [record.businessUnitId, record.name])
    );
  }
  
  const fetchDataSourceSegmentId = async function () {
    let records = null;
    try {
      records = await ApiService.getSegments(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceSegmentId(
      records.map((record) => [record.segmentId, record.name])
    );
  }
  
  const fetchDataSourceBranchId = async function () {
    let records = null;
    try {
      records = await ApiService.getBranches(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceBranchId(
      records.map((record) => [record.branchId, record.name])
    );
  }
  
  const fetchDataSourceUserId = async function () {
    let records = null;
    try {
      records = await ApiService.getUsers(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceUserId(
      records.map((record) => [record.userId, protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.firstName, record.lastName ])])
    );
  }
  
  const loadCount = async function () {
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.operationTypeIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.businessUnitIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.segmentIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.branchIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.userIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.statuss = filtersValues[5].join(',');
      }
      setCount(await ApiService.getCountBudgetOperations(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.operationTypeIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.businessUnitIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.segmentIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.branchIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.userIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.statuss = filtersValues[5].join(',');
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBudgetOperations(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.budgetOperationId,
      data: [
        record.operationTypeName,
        record.operationTypeCode,
        record.businessUnitName,
        record.businessUnitCode,
        record.segmentName,
        record.segmentCode,
        record.branchName,
        record.branchCode,
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.userFirstName, record.userLastName ]),
        record.userUsername,
        record.status,
        record.janCount,
        record.febCount,
        record.marCount,
        record.aprCount,
        record.mayCount,
        record.junCount,
        record.julCount,
        record.augCount,
        record.sepCount,
        record.octCount,
        record.novCount,
        record.decCount,
      ],
      record: record
    })));
  }
  
  const exportRecords = async function () {
    let data = null;
    try {
      const args = {};
      if (filtersValues[0] !== null && filtersValues[0] !== undefined) {
        args.operationTypeIds = filtersValues[0].join(',');
      }
      if (filtersValues[1] !== null && filtersValues[1] !== undefined) {
        args.businessUnitIds = filtersValues[1].join(',');
      }
      if (filtersValues[2] !== null && filtersValues[2] !== undefined) {
        args.segmentIds = filtersValues[2].join(',');
      }
      if (filtersValues[3] !== null && filtersValues[3] !== undefined) {
        args.branchIds = filtersValues[3].join(',');
      }
      if (filtersValues[4] !== null && filtersValues[4] !== undefined) {
        args.userIds = filtersValues[4].join(',');
      }
      if (filtersValues[5] !== null && filtersValues[5] !== undefined) {
        args.statuss = filtersValues[5].join(',');
      }
      data = await ApiService.getBudgetOperationsExport(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    download('Export.csv', data);
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  const handleClickItem = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    history.push('/budget-operation/' + item.record.budgetOperationId);
  }
  
  const handleContextualAction0 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetOperation = null;
    try {
      budgetOperation = await ApiService.getBudgetOperation(item.record.budgetOperationId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 0, budgetOperation: budgetOperation });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setContextualActionPath(path);
  }
  const submitContextualAction0 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction0.current)) {
      try {
        await ApiService.putBudgetOperationSetInRevision(contextualActionPath.budgetOperationId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const handleContextualAction1 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetOperation = null;
    try {
      budgetOperation = await ApiService.getBudgetOperation(item.record.budgetOperationId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 1, budgetOperation: budgetOperation });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setContextualActionPath(path);
  }
  const submitContextualAction1 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction1.current)) {
      try {
        await ApiService.putBudgetOperationSetConfirmed(contextualActionPath.budgetOperationId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const handleContextualAction2 = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    let budgetOperation = null;
    try {
      budgetOperation = await ApiService.getBudgetOperation(item.record.budgetOperationId);
    }
    catch (error) {
      setError(error);
      return;
    }
    setContextualAction({ index: 2, budgetOperation: budgetOperation });
    const path = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    setContextualActionPath(path);
  }
  const submitContextualAction2 = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRefContextualAction2.current)) {
      try {
        await ApiService.putBudgetOperationSetSent(contextualActionPath.budgetOperationId, contextualActionBody);
      }
      catch (error) {
        setError(error);
        return;
      }
      setContextualAction(null);
      setContextualActionPath(null);
      setContextualActionValidated(null);
      refreshMe();
    }
    else {
      setContextualActionValidated(true);
    }
  }
  const updateContextualActionData = function (field, value) {
    setContextualActionData({ ...contextualActionData, [field]: value });
  }
  const updateContextualActionPath = function (field, value) {
    setContextualActionPath({ ...contextualActionPath, [field]: value });
  }
  const updateContextualActionBody = function (field, value) {
    setContextualActionBody({ ...contextualActionBody, [field]: value });
  }
  const cancelContextualAction = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setContextualAction(null);
    setContextualActionData(null);
    setContextualActionValidated(null);
  }
  
  return (
    <div>
      <div>
        <div className="d-flex align-items-center">
        <div className="pe-3">
          <div className="p-1 rounded text-black hov-black cursor-pointer" onClick={(e) => exportRecords(e)}>
            <IconDownload size="sm" />
          </div>
        </div>
          <FiltersBar
            sessionStorageKey="filtersOperations"
            filters={[
              {
                label: words.operationTypeShort,
                variant: 'option',
                dataSource: dataSourceOperationTypeId
              },
              {
                label: words.businessUnitShort,
                variant: 'option',
                dataSource: dataSourceBusinessUnitId
              },
              {
                label: words.segment,
                variant: 'option',
                dataSource: dataSourceSegmentId
              },
              {
                label: words.branch,
                variant: 'option',
                dataSource: dataSourceBranchId
              },
              {
                label: words.officer,
                variant: 'option',
                dataSource: dataSourceUserId
              },
              {
                label: words.status,
                variant: 'option',
                dataSource: [['inRevision', words.inRevision], ['confirmed', words.confirmed], ['sent', words.sent]]
              },
            ]}
            filtersValues={filtersValues}
            setFiltersValues={setFiltersValues}
          />
          <div className="flex-grow-1" />
        </div>
        <Grid
          contextualActions={[
            { icon: IconStatus, label: words.moveToRevision, color: 'red', onClick: handleContextualAction0, hidden: function (item) { return !(protect(function ([status]) { return status === 'confirmed' }, [ item.record.status ]) && (SecurityService.hasRole('administrator'))) } },
            { icon: IconStatus, label: words.confirmCounts, color: 'yellow', onClick: handleContextualAction1, hidden: function (item) { return !(protect(function ([status]) { return status === 'inRevision' }, [ item.record.status ]) && (SecurityService.hasRole('officer'))) } },
            { icon: IconStatus, label: words.sendCounts, color: 'green', onClick: handleContextualAction2, hidden: function (item) { return !(protect(function ([status]) { return status === 'confirmed' }, [ item.record.status ]) && (SecurityService.hasRole('administrator'))) } },
          ]}
          fields={[
            {
              label: words.operationTypeShort,
              type: 'string',
              bindIndex: 0,
              secondaryField: {
                type: 'string',
                bindIndex: 1,
              },
            },
            {
              label: words.businessUnitShort,
              type: 'string',
              bindIndex: 2,
              secondaryField: {
                type: 'string',
                bindIndex: 3,
              },
            },
            {
              label: words.segment,
              type: 'string',
              bindIndex: 4,
              secondaryField: {
                type: 'string',
                bindIndex: 5,
              },
            },
            {
              label: words.branch,
              type: 'string',
              bindIndex: 6,
              secondaryField: {
                type: 'string',
                bindIndex: 7,
              },
            },
            {
              label: words.officer,
              type: 'string',
              bindIndex: 8,
              secondaryField: {
                type: 'string',
                bindIndex: 9,
              },
            },
            {
              label: words.status,
              type: 'string',
              translate: true,
              variant: 'framed-text',
              color: function (value) { return value === 'inRevision' ? 'red' : (value === 'confirmed' ? 'yellow' : (value === 'sent' ? 'green' : 'black')); },
              alignment: 'center',
              bindIndex: 10,
            },
            {
              label: words.jan,
              type: 'integer',
              alignment: 'right',
              bindIndex: 11,
            },
            {
              label: words.feb,
              type: 'integer',
              alignment: 'right',
              bindIndex: 12,
            },
            {
              label: words.mar,
              type: 'integer',
              alignment: 'right',
              bindIndex: 13,
            },
            {
              label: words.apr,
              type: 'integer',
              alignment: 'right',
              bindIndex: 14,
            },
            {
              label: words.may,
              type: 'integer',
              alignment: 'right',
              bindIndex: 15,
            },
            {
              label: words.jun,
              type: 'integer',
              alignment: 'right',
              bindIndex: 16,
            },
            {
              label: words.jul,
              type: 'integer',
              alignment: 'right',
              bindIndex: 17,
            },
            {
              label: words.aug,
              type: 'integer',
              alignment: 'right',
              bindIndex: 18,
            },
            {
              label: words.sep,
              type: 'integer',
              alignment: 'right',
              bindIndex: 19,
            },
            {
              label: words.oct,
              type: 'integer',
              alignment: 'right',
              bindIndex: 20,
            },
            {
              label: words.nov,
              type: 'integer',
              alignment: 'right',
              bindIndex: 21,
            },
            {
              label: words.dec,
              type: 'integer',
              alignment: 'right',
              bindIndex: 22,
            },
          ]}
          onClickItem={(SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) && (SecurityService.hasRole('administrator') || SecurityService.hasRole('officer')) ? handleClickItem : null}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
      {contextualAction && contextualAction.index === 0 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="red" label={words.moveToRevision} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction0} className="p-0">
            <div className="p-2">
              <HomeBodyPart2ContextualAction1 budgetOperation={contextualAction ? contextualAction.budgetOperation : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="red" onClick={submitContextualAction0} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {contextualAction && contextualAction.index === 1 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="yellow" label={words.confirmCounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction1} className="p-0">
            <div className="p-2">
              <HomeBodyPart2ContextualAction2 budgetOperation={contextualAction ? contextualAction.budgetOperation : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="yellow" onClick={submitContextualAction1} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
      {contextualAction && contextualAction.index === 2 ?
        <ReactBootstrap.Modal
          show={true}
          onHide={() => cancelContextualAction({})}
          scrollable={true}
          centered={true}
         
        >
          <ReactBootstrap.Modal.Header className="pt-2 pb-1 ps-2 pe-3" closeButton={true}>
            <Title level={1} icon={IconStatus} color="green" label={words.sendCounts} />
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body ref={bodyRefContextualAction2} className="p-0">
            <div className="p-2">
              <HomeBodyPart2ContextualAction3 budgetOperation={contextualAction ? contextualAction.budgetOperation : null} />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer className="p-2">
            <div>
              <Button label={words.yes} color="green" onClick={submitContextualAction2} />
            </div>
            <div>
              <Button label={words.no} color="blue" onClick={cancelContextualAction} />
            </div>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal> :
        null
      }
    </div>
  );
})

export default HomeBodyPart2;
